import styles from "./VideoControls.module.css";

export function addFullScreenClass(baseClass: string, isFullscreen: boolean) {
	return `${baseClass} ${isFullscreen ? styles.fs : ""}`;
}
